import React from "react";
import { Nav } from "react-bootstrap";
import "./Footer.scss";

const newDate = new Date()
const currentYear = newDate.getFullYear();

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer--inner">
        <Nav bsPrefix="footer--inner--nav">
          <Nav.Link
            bsPrefix="footer--inner--nav--link"
            href="https://www.tysonfoods.com/legal/terms-of-use"
            target="_blank"
            rel="noreferrer noopener"
          >
            Terms of Use
          </Nav.Link>
          <Nav.Link
            bsPrefix="footer--inner--nav--link"
            href="https://www.tysonfoods.com/legal/privacy-policy"
            target="_blank"
            rel="noreferrer noopener"
          >
            Privacy Policy
          </Nav.Link>
          <Nav.Link
            bsPrefix="footer--inner--nav--link"
            href="https://www.tyson.com/our-story/"
            target="_blank"
            rel="noreferrer noopener"
          >
            About Tyson
          </Nav.Link>

          <Nav.Link
            bsPrefix="footer--inner--nav--link"
            href="https://www.tyson.com/contact-us/"
            target="_blank"
            rel="noreferrer noopener"
          >
            Contact
          </Nav.Link>
          <Nav.Link
            bsPrefix="footer--inner--nav--link"
            href="https://app.keysurvey.com/f/1463959/4ffd/"
            target="_blank"
            rel="noreferrer noopener"
          >
            Do Not Sell Or Share My Personal Information
          </Nav.Link>
        </Nav>
        <div className="footer--inner--copyright">
          <span className="footer--inner--copyright--span">
            ©{currentYear} Tyson Foods, Inc. Trademarks And Registered Trademarks are
            owned by Tyson Foods, Inc. or its Subsidiaries.
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
